import React, { Component } from 'react';
import { TransparentButton, ButtonType } from '@checkmarx/cx-ui'

export default class SsoLoginForm extends Component {

    render(){

        let externalLoginUrl = `./identity/externalLogin`;

        return (
            <form action={externalLoginUrl} method='post'>
                <div>
                <input type='hidden' name='redirectUrl' value={this.props.returnUrl}/>
                    <div style={{marginBottom: '15px'}}>
                        <TransparentButton 
							buttonType={ButtonType.blue}
                            dataCy='btn-external-login'
                            name='providerid'
                            value={this.props.provider.id}
                            text={this.props.provider.name}
                            style={{
								color:'#4a90e2', 
                                borderColor:'#4a90e2',
                                height:'40px',
                                width:'325px',
                                textTransform: 'initial',
                                fontSize:'15px',
                                whiteSpace: 'nowrap',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis'}}>
                        </TransparentButton>
                    </div>
                </div>
            </form>
        );    
    }
}